export default {
    state: {
        incidents: [],
        incident_id: null,
        url: '/api/hms/compliances/incidents',
        form: {
            urgent: false,
            life_threatening: false,
            housing_type: '',
            date: null,
            time: '',
            facility_id: '',
            incident_type: '',
            involved: false,
            responder: false,
            injury: false,
            involvedData: [{
                type: '',
                name: '',
                gender: '',
                ssn: '',
                dob: null,
            }],
            responderData: [{
                name: '',
                responder: '',
                time_called: '',
                time_arrived: '',
                badge: '',
                unit: '',
                comments: '',
            }],
            injuryData: [{
                name: '',
                type: '',
                moved_to_hospital: false,
                hospital_name: '',
            }],
            description: '',
            action_taken: '',
            res_statements: [],
            other_statement: false,
            res_other: '',
            prepared_by: '',
            prepared_title: '',
            prepared_date: null,
        },
        errors: {},
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },

        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'date', label: 'Date', sortable: true, tdClass: 'text-muted'},
                {key: 'time', label: 'Time', sortable: true, tdClass: 'text-muted'},
                {key: 'priority', label: 'Priority', sortable: true, tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'incident_type', label: 'Incident Type', sortable: true, tdClass: 'text-muted'},
                {key: 'reviewed_by', label: 'Reviewed By', sortable: true, tdClass: 'text-muted'},
                {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        }
    },

    getters: {
        getIncidentForm: state => state.form,

        getIncidentErrors: state => state.errors,

        getIncidentsMeta: state => state.meta,

        getIncidentTableFields: state => state.table.fields,
    },

    mutations: {
        setIncidents: (state, payload) => {
            state.incidents = payload;
        },

        setIncidentForm: state => {
            state.form = {
                urgent: false,
                life_threatening: false,
                housing_type: '',
                date: null,
                time: '',
                facility_id: '',
                incident_type: '',
                involved: false,
                responder: false,
                injury: false,
                involvedData: [{
                    type: '',
                    name: '',
                    gender: '',
                    ssn: '',
                    dob: null,
                }],
                responderData: [{
                    name: '',
                    responder: '',
                    time_called: '',
                    time_arrived: '',
                    badge: '',
                    unit: '',
                    comments: '',
                }],
                injuryData: [{
                    name: '',
                    type: '',
                    moved_to_hospital: false,
                    hospital_name: '',
                }],
                description: '',
                action_taken: '',
                res_statements: [],
                other_statement: false,
                res_other: '',
                prepared_by: '',
                prepared_title: '',
                prepared_date: null,
            };

            state.errors = {};
        },

        setIncidentErrors: (state, payload) => {
            state.errors = payload;
        },

        setIncidentsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        resetIncidentsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        resetIncidentInvolvedData: state => {
            state.form.involvedData = [{
                type: '',
                name: '',
                gender: '',
                ssn: '',
                dob: null,
            }];

            state.errors = {};
        },

        resetIncidentResponderData: state => {
            state.form.responderData = [{
                responder: '',
                time_called: '',
                time_arrived: '',
                name: '',
                badge: '',
                unit: '',
                comments: '',
            }];

            state.errors = {};
        },

        resetIncidentInjuryData: state => {
            state.form.injuryData = [{
                name: '',
                type: '',
                moved_to_hospital: false,
                hospital_name: '',
            }];

            state.errors = {};
        },
    },

    actions: {
        fetchIncidents: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url, {params: parameters})
                    .then(response => {
                        commit('setIncidents', response.data);

                        commit('setIncidentsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        if(error.response.data.errors) {
                            commit('setIncidentErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            });
        },

        submitIncident: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if(error.response.data.errors) {
                            commit('setIncidentErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        updateIncident: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.incident_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setIncidentErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        fetchEditIncident: ({state, commit}, incident_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + incident_id + '/edit')
                    .then(response => {
                        state.incident_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    }
}
